import { ConcreteRequest } from "relay-runtime";

import cskQueryLiveResourceMetadataQuery from "@src/__generated__/relay/cskQueryLiveResourceMetadataQuery.graphql";
import cskQueryZephrDataContainerQuery from "@src/__generated__/relay/cskQueryZephrDataContainerQuery.graphql";

/*
 * This file is for exported GQL queries for CSK pages to consume. See
 * src/utils/csk-query.ts for details.
 */
export const ZEPHR_DATA_CONTAINER_CONCRETE_REQUEST: ConcreteRequest =
  cskQueryZephrDataContainerQuery;

export const LIVE_RESOURCE_METADATA_CONCRETE_REQUEST: ConcreteRequest =
  cskQueryLiveResourceMetadataQuery;
